/** localStorage key (prefixed by occyLs APP_IDENTIFIER). */
export const PERMISSION_DENIED_MODAL_PREFERENCES_KEY =
  'permissionDeniedModalPreferences';

/** Wait for parallel denials before opening the modal (single permission). */
export const DEFAULT_DENIAL_BATCH_MS = 600;

/** Extra time when a denied perm may be part of a stored multi-permission group. */
export const SUPPRESSED_GROUP_DENIAL_BATCH_MS = 3000;
